export class ColorUtils {

  /**
   * Interpolates between two colors based on a factor.
   * @param color1 The start color in HEX format.
   * @param color2 The end color in HEX format.
   * @param factor The interpolation factor (0 to 1).
   * @returns The interpolated color in HEX format.
   */
  static interpolateColors(color1: string, color2: string, factor: number): string {
    const rgb1 = this.hexToRgb(color1);
    const rgb2 = this.hexToRgb(color2);

    const resultRgb = {
      r: Math.round(rgb1.r + factor * (rgb2.r - rgb1.r)),
      g: Math.round(rgb1.g + factor * (rgb2.g - rgb1.g)),
      b: Math.round(rgb1.b + factor * (rgb2.b - rgb1.b))
    };

    return this.rgbToHex(resultRgb.r, resultRgb.g, resultRgb.b);
  }

  static hexToRgb(hex: string): { r: number, g: number, b: number } {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, (m, r, g, b) => {
      return r + r + g + g + b + b;
    });

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : { r: 0, g: 0, b: 0 };
  }

  static rgbToHex(r: number, g: number, b: number): string {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }

  static componentToHex(c: number): string {
    const hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
}
